import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { WithMultiSimulationGroupMenu as Component } from './WithMultiSimulationGroupMenu.component';

export interface IOwnProps {
  isCollapsed?: boolean;
  selectedPage: string;
}

export type IStateProps = ReturnType<typeof mapStateToProps>;
export type IDispatchProps = typeof mapDispatchToProps;
export type IInjectedProps = IStateProps & IDispatchProps;
export type IProps = IOwnProps & IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  return {
    routeMultiSimulationGroup: selectRouteResource(rrc.multi_simulation_group)(rootState),
  };
};

const mapDispatchToProps = {};

export const WithMultiSimulationGroupMenu = connect(mapStateToProps, mapDispatchToProps)(Component);
